import { IonPage, IonContent, IonHeader } from "@ionic/react";
import { Business } from "@mui/icons-material";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Skeleton,
} from "@mui/material";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import GenerateCodeModal from "../../components/generate-code-modal";
import GenerateCodeTable from "../../components/generate-code-table";
import styles from "./ManageStaff.module.css";
import { useBusinessContext } from "../../context/business-context";
import StaffModal from "../../components/staffs/manage-staff-modal";
import StaffsTable from "../../components/staffs/staffs-table";
import { baseUrl, config, getBusinessData, requestID } from "../../common/utils";
import axios from "axios";
import AlertDialog from "../../components/dialog";
import { useHistory } from "react-router";
import { bus } from "ionicons/icons";
import MemberModal from "../../components/staffs/manage-member-modal";
// import AlertDialog from "../../components/dialog";

const CreateMember = () => {
  // const {
  //   selectedBusinessId,
  //   setSelectedBusinessId,
  //   selectedBusinessTypeId,
  //   setSelectedBusinessTypeId,
  //   selectedBusinessName,
  //   setSelectedBusinessName,
  //   selectedBusinessTypeName,
  //   setSelectedBusinessTypeName,
  //   selectedRoleID,
  //   setSelectedRoleID,
  //   selectedRoleName,
  //   selectedBusiness
  // } = useBusinessContext();



  const {business_id,business_type_id,name} = getBusinessData()
  // console.log({businessData});


  // const { selectedBusinessId } = useBusinessContext();
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [branches, setBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [activatationList, setActivatationList] = useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [selectedStaff, setSelectedStaff] = React.useState(null);

  const history = useHistory();

  const getRoles = async () => {
    // try {
    setStatus({ loading: true, error: false });
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", business_id);
    formData.append("business_type", business_type_id);
    

    console.log(formData);
    const response = await axios.post(
      baseUrl() + "settings/getRoles",
      formData,
      config
    );
    console.log({ response });
    const data = await response.data.data;
    setRoles(data);
    setStatus({ loading: false, error: false });
  };

  const getBranches = async () => {
    // try {
    setStatus({ loading: true, error: false });

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", business_id);
    formData.append("business_type", business_type_id);


    console.log(formData);

    const response = await axios.post(
      baseUrl() + "businesss/getMyMembersList_member",
      formData,
      config
    );
    console.log({ response });

    const data = await response.data.data;
    console.log(data);
    setBranches(data[2]);
    setRoles(data[1]);
    setActivatationList(data[0]);
    setStatus({ loading: false, error: false });
    // } catch (error) {
    console.error();
    //   setAlertMsg(error.response.data.message);
    // onShowAlert();
    // }
  };



  useEffect(() => {
    getRoles();
    getBranches();
  }, []);

  const onDeleteStaff = (staff) => {
    setOpenDeleteDialog(true);
    setSelectedStaff(staff);
  };

  const handleConfirm = async () => {
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", business_id);
      formData.append("business_type", business_type_id);
      formData.append("branch_id", selectedStaff.branch_id);
      formData.append("user_id", selectedStaff.user_id);
      const response = await axios.post(
        baseUrl() + "staffs/deleteStaff",
        formData,
        config
      );
      console.log(response);
      const data = await response.data.data;
      console.log(data);
      setStatus({ loading: false, error: false });
      setOpenDeleteDialog(false);
      getBranches();
    } catch (error) {
      console.log(error);
      setStatus({ loading: false, error: true });
    }
  };
  return (
    <IonPage className="ion-padding">
      <IonHeader style={{ backgroundColor: "white" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
            {name && name && (
              <>
                {name.toUpperCase()} -{" "}
                {name}
              </>
            )}{" "}
            - Manage Staff
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsModalOpen(true)}
          >
            Add New Member
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => history.goBack()}
            style={{ marginLeft: 10 }}
          >
            Go Back
          </Button>
        </Box>
      </IonHeader>

      <IonContent fullscreen className={styles.container}>
        {!status.loading ? (
          <StaffsTable
            rows={activatationList}
            setOpenModal={setIsModalOpen}
            onDeleteStaff={onDeleteStaff}
            setSelectedStaff={setSelectedStaff}
          />
        ) : (
          <Grid container spacing={1}>
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Grid item xs={12} sm={12} md={12} key={item}>
                <Card className={styles.skeletonCard}>
                  <CardContent>
                    <Skeleton variant="rectangular" height={30} width="100%" />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        <MemberModal
          branches={branches}
          roles={roles}
          isOpen={isModalOpen}
          selectedStaff={selectedStaff}
          onClose={() => {
            setIsModalOpen(false), setSelectedStaff(null);
          }}
          onGetactivationList={() => getBranches()}
        />




        <AlertDialog
          open={openDeleteDialog}
          title="Delete Staff?"
          description={`Are you sure you want to remove ${selectedStaff?.fullName}  as a Staff from this business??`}
          onClose={() => setOpenDeleteDialog(false)}
          onConfirm={handleConfirm}
          confirmText="Agree"
          cancelText="Disagree"
        />
      </IonContent>
    </IonPage>
  );
};


export default CreateMember;
